import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { totalUnitNameConfig } from './TotalUnit.name';

enum TotalUnit {
  specifySelection = '0',
  specifyInput = '1',
}

const totalUnitMap = new Map([
  ['0', TotalUnit.specifySelection],
  ['1', TotalUnit.specifyInput],
]);

const rawValueToTotalUnit = rawValueToEnumWithDefault(totalUnitMap, TotalUnit.specifyInput);

const totalUnitToDisplay = enumToNameWithDefault(TotalUnit, totalUnitNameConfig);

const totalUnitToDisplayWithPrefix = enumToNameWithDefault(TotalUnit, totalUnitNameConfig, true);

export { TotalUnit, rawValueToTotalUnit, totalUnitToDisplay, totalUnitToDisplayWithPrefix };
